import { Stack, Text, useTheme } from "@bps/fluent-ui";
import {
  DeviceAdvancedSearchArgs,
  DeviceDetail
} from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useDeviceAdvancedSearch } from "@libs/api/gateways/field/field-ops-gateway.hooks";
import { getPagesResult } from "@libs/paging/paging.utils";

import { DeviceSearchResultsTable } from "./DeviceSearchResultsTable";

interface DeviceSearchResultsProps {
  args: DeviceAdvancedSearchArgs;
  customColumns: string[];
  setSelectedDevices: (devices: DeviceDetail[]) => void;
}

export const DeviceSearchResults = ({
  args,
  customColumns,
  ...props
}: DeviceSearchResultsProps) => {
  const theme = useTheme();

  const query = useDeviceAdvancedSearch(args);
  const { data, hasNextPage, fetchNextPage, isLoading, error } = query;

  const devices = getPagesResult(data);

  const handleScrolledToBottom = async () => {
    if (hasNextPage) {
      await fetchNextPage();
    }
  };

  return (
    <Stack
      styles={{
        root: {
          overflow: "hidden",
          height: "100%",
          background: theme.semanticColors.bodyBackground,
          paddingTop: theme.spacing.s1,
          paddingBottom: theme.spacing.s1
        }
      }}
    >
      <Stack
        styles={{
          root: { alignItems: "end", display: "flex", margin: 4 }
        }}
      >
        <Text
          styles={{
            root: {
              background: theme.semanticColors.listItemBackgroundChecked,
              width: "fit-content",
              padding: 2
            }
          }}
        >
          {data?.pages[0]?.results !== null ? data?.pages[0]?.total ?? 0 : 0}{" "}
          records found
        </Text>
      </Stack>

      {devices.length === 0 && !isLoading ? (
        <Stack horizontalAlign="center">
          <Text variant="small">
            Your search returned no results, please refine your search term(s).
          </Text>
        </Stack>
      ) : (
        <DeviceSearchResultsTable
          items={devices ?? []}
          customColumns={customColumns}
          setKey="device-search-results-table"
          hasNextPage={hasNextPage}
          handleScrolledToBottom={handleScrolledToBottom}
          error={error ?? undefined}
          isLoading={isLoading}
          {...props}
        />
      )}
    </Stack>
  );
};
